<template>
  <div
    ref="winning"
    class="push-winning-virtual"
  >
    <div class="won-picture-container">
      <img
        class="won-picture"
        src="../images/won.png"
      >

      <div
        v-if="logoPicUrl"
        class="sport-logo-container"
      >
        <img
          :src="logoPicUrl"
          class="sport-logo"
        >
      </div>
    </div>

    <div class="winning-main">
      <div class="title">
        MSport Virtual Sport
      </div>

      <div class="total-winning">
        + {{ $t('CURRENCY') }} {{ totalWinnings }}
      </div>

      <div class="btn-groups">
        <!-- check detail -->
        <VButton
          class="detail-btn"
          @click="checkDetails"
        >
          <span class="text">Check Details</span>
        </VButton>

        <!-- save -->
        <VButton
          class="v-button save-btn"
          :loading="drawLoading"
          @click="handleSave"
        >
          <span class="text">Save</span>
        </VButton>
      </div>
    </div>

    <DrawElement
      ref="drawContainer"
      class="draw-container"
      :total-winnings="totalWinnings"
      :logo-pic-url="logoPicUrl"
    />
  </div>
</template>

<script>
// virtual 中奖弹窗
import VButton from 'fe-vui/button'
import VDialog from 'fe-vui/dialog'
import DrawElement from './DrawElement'
import { drawHtml } from '@ms/utils/draw.js'
import download from 'wap/utils/download.js'
import { tryAppSaveImage } from 'wap/hybrid'
import modalHelper from '@ms/utils/scroll-fixed'

export default {
  name: 'PushWinning',
  components: {
    VButton,
    DrawElement
  },
  props: {
    // 2 代表 virtual
    bizType: {
      type: Number,
      default: 0
    },
    totalWinnings: {
      type: String,
      default: '240'
    },
    orderId: {
      type: String,
      default: ''
    },
    // sport logo
    logoPicUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      drawLoading: false
    }
  },
  methods: {
    checkDetails() {
      // virtual order detail
      const { query } = window.router.currentRoute
      const currentQuery = Object.assign({}, query)
      modalHelper.beforeClose()
      VDialog.close()
      window.router.push({
        name: 'virtualOrderDetail',
        params: { orderId: this.orderId },
        query: currentQuery
      })
    },
    loadImage(selector) {
      return new Promise((resolve) => {
        const img = document.querySelector(selector)
        if (!img || img.complete) {
          return resolve()
        }
        img.onload = () => {
          return resolve()
        }
        img.onerror = () => {
          return resolve()
        }
      })
    },
    async handleSave() {
      this.drawLoading = true
      await Promise.all([this.loadImage('.virtual-draw-element .banner-won'), this.loadImage('.virtual-draw-element .sport-logo')])
      this.downloadImage()
    },
    handleDownload(data) {
      tryAppSaveImage(data, () => {
        download(data, 'virtual_winning')
      })
    },
    downloadImage() {
      this.$nextTick(() => {
        const el = document.querySelector('.draw-container')
        drawHtml(el, {
          scale: 2
        }).then(({ data }) => {
          this.handleDownload(data)
          this.drawLoading = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~wap/common/style/variable.less");

.push-winning-virtual {
  overflow: hidden;
  width: 280px;
  border-radius: 4px;
  margin: 0 auto;

  .won-picture-container {
    position: relative;
  }

  .won-picture {
    width: 280px;
    height: 166px;
  }

  .winning-main {
    padding: 12px 0 25px;
    background: #f8f8f8;
    text-align: center;

    .title {
      color: #333;
      font-size: 14px;
      line-height: 16px;
    }

    .total-winning {
      margin: 12px auto 15px;
      color: #ff751a;
      font-size: 30px;
      font-weight: bold;
      line-height: 35px;
    }
  }
}

.btn-groups {
  display: flex;
  justify-content: center;
}
</style>

<style lang="less">
@import url("~wap/common/style/variable.less");

.virtual-push-dialog {
  .dialog {
    // 固定宽
    width: 280px;
    height: auto;
    background: transparent;

    .m-close-btn {
      top: 71px;
      right: 0;
      color: #fff;

      svg {
        font-size: 16px;
      }
    }

    .dialog--main {
      height: 100%;
    }
  }

  .sport-logo-container {
    position: absolute;
    top: 22px;
    left: 50%;
    width: 60px;
    height: 60px;
    box-sizing: border-box;
    margin-left: -31px;
    text-align: center;

    .sport-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      width: 100%;
      height: 100%;
      margin-top: -30px;
      margin-left: -30px;
    }
  }

  .draw-container {
    position: absolute;
    z-index: 9999;
    top: 0;
    right: 10000px;
  }

  .icon-loading {
    width: 22px;
    height: 22px;
    color: #fff;
  }

  .push-winning-virtual {
    .v-button {
      width: 104px;
      height: 26px;
      padding: 0;
      border-radius: 18px;
      background: #00b359;
      color: #fff;
      font-size: 12px;
      line-height: 26px;

      &:active {
        opacity: 0.8;
      }

      &.save-btn {
        margin-left: 20px;
      }

      .text {
        display: inline-block;
        padding-left: 15px;
      }

      &.detail-btn .text {
        background: url("../images/icon-detail.png") no-repeat 0 6px;
        background-size: 11px 11px;
      }

      &.save-btn .text {
        background: url("../images/icon-save.png") no-repeat 0 center;
        background-size: 11px 11px;
      }
    }
  }
}
</style>
